import React, { useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { api, confirmedWrite } from "./api";
import useDispatchConfirmation from "./useDispatchConfirmation";
import {
  Field,
  Lookup,
  Select,
  Pager,
  Status,
  TYPES,
  date,
  dispatchName,
  today,
  target,
  useData,
} from "./common";
export function Filters({ onApply, report = false, includeDates = true }) {
  const [f, setF] = useState(
    report && includeDates
      ? { desde: today().slice(0, 7) + "-01", hasta: today() }
      : {}
  );
  const [dest, setDest] = useState(null),
    [item, setItem] = useState(null),
    [op, setOp] = useState(null),
    [by, setBy] = useState(null),
    [customer, setCustomer] = useState(null);
  const set = (k, v) => setF({ ...f, [k]: v });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onApply({
          ...f,
          destinoId: dest?._id,
          insumoId: item?._id,
          operadorId: op?._id,
          despachadoPor: by?._id,
          quickBooksId: customer?.quickBooksId,
          realmId: customer?.realmId,
          businessUnit: customer?.businessUnit,
        });
      }}
    >
      <div className="sd-grid">
        {includeDates && (
          <>
            <Field title="Desde">
              <input
                type="date"
                value={f.desde || ""}
                onChange={(e) => set("desde", e.target.value)}
              />
            </Field>
            <Field title="Hasta">
              <input
                type="date"
                value={f.hasta || ""}
                onChange={(e) => set("hasta", e.target.value)}
              />
            </Field>
          </>
        )}
        <Select
          title="Canal"
          value={f.canal}
          options={["RUTA", "CLIENTE", "NINGUNO"]}
          onChange={(v) => set("canal", v)}
          empty="Todos"
        />
        <Select
          title="Tipo"
          value={f.tipo}
          options={TYPES}
          onChange={(v) => set("tipo", v)}
          empty="Todos"
        />
        {!report && (
          <Select
            title="Estado"
            value={f.estado}
            options={["SOLICITADO", "ENTREGADO", "ANULADO"]}
            onChange={(v) => set("estado", v)}
            empty="Todos"
          />
        )}
        <Lookup
          title="Destino"
          path="destinos"
          active={false}
          value={dest}
          onChange={setDest}
        />
        <Lookup
          title="Insumo"
          path="insumos"
          active={false}
          value={item}
          onChange={setItem}
        />
        <Lookup
          title="Cliente"
          path="clientes"
          value={customer}
          onChange={setCustomer}
        />
        <Lookup
          title="Operador"
          path="operadores"
          value={op}
          onChange={setOp}
        />
        <Lookup
          title="Despachado por"
          path="operadores"
          value={by}
          onChange={setBy}
        />
        <Field title="Solo excepcionales">
          <input
            type="checkbox"
            checked={!!f.soloExcepcionales}
            onChange={(e) => set("soloExcepcionales", e.target.checked)}
          />
        </Field>
        {report && (
          <Field title="Excluir excepcionales">
            <input
              type="checkbox"
              checked={!!f.excluirExcepcionales}
              onChange={(e) => set("excluirExcepcionales", e.target.checked)}
            />
          </Field>
        )}
      </div>
      <Button label="Aplicar filtros" type="submit" />
    </form>
  );
}
export function MovementTable({ rows, onDetail, onState, busy }) {
  return (
    <DataTable
      value={rows || []}
      emptyMessage="Sin movimientos"
      responsiveLayout="scroll"
      className="p-datatable-sm sd-sticky-table"
      dataKey="_id"
    >
      <Column
        field="sequence"
        header="#"
        body={(r) => (
          <button
            type="button"
            className="sd-sequence"
            onClick={() => onDetail(r._id)}
            aria-label={`Ver movimiento ${r.sequence}`}
          >
            {r.sequence ?? "Sin consecutivo"}
          </button>
        )}
      />
      <Column header="Fecha" body={(r) => date(r.operationDate)} />
      <Column field="type" header="Tipo" />
      <Column header="Destino / cliente" body={target} />
      <Column field="operator.name" header="Titular" />
      <Column field="collectedBy.name" header="Retiró" />
      <Column header="Líneas" body={(r) => r.lines.length} />
      <Column field="dispatchedBy.name" header="Despachó" body={dispatchName} />
      <Column field="state" header="Estado" body={(r) => onState && ["SOLICITADO", "ENTREGADO"].includes(r.state) ? (
        <select aria-label={`Estado pedido ${r.sequence}`} value={r.state}
          disabled={busy || r.state === "ENTREGADO"}
          onChange={(e) => { if (e.target.value === "ENTREGADO") onState(r); }}>
          <option value="SOLICITADO">Solicitado</option>
          <option value="ENTREGADO">Entregado</option>
        </select>
      ) : r.state} />
      <Column
        header="Acciones"
        body={(r) => <Button label="Detalle" onClick={() => onDetail(r._id)} />}
      />
    </DataTable>
  );
}
export default function Ledger({ onDetail, operatorOnly = false }) {
  const scope = operatorOnly ? { operatorRequest: true } : {};
  const [filters, setFilters] = useState({}),
    [page, setPage] = useState(1),
    [exporting, setExporting] = useState(false),
    [error, setError] = useState("");
  const state = useData("movimientos", {
    ...filters,
    ...scope,
    page,
  });
  return (
    <section>
      <h2>{operatorOnly ? "Historico - Operador" : "Histórico"}</h2>
      <Filters
        onApply={(f) => {
          setFilters(f);
          setPage(1);
        }}
      />
      <div className="sd-toolbar">
        <Button
          label="Exportar Excel"
          loading={exporting}
          onClick={async () => {
            setExporting(true);
            setError("");
            try {
              await api(
                "movimientos",
                "GET",
                undefined,
                {
                  ...filters,
                  ...scope,
                  formato: "xlsx",
                },
                true
              );
            } catch (e) {
              setError(e.message);
            } finally {
              setExporting(false);
            }
          }}
        />
      </div>
      <Status {...state} error={state.error || error} />
      <MovementTable rows={state.data?.rows} onDetail={onDetail} />
      {state.data && <Pager data={state.data} page={page} setPage={setPage} />}
    </section>
  );
}
export function Home({ onDetail, go, canOperate, canRequest }) {
  const [page, setPage] = useState(1), [refresh, setRefresh] = useState(0), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const { confirm, dialog } = useDispatchConfirmation();
  const movements = useData("movimientos", { inicio: true, desde: today(), hasta: today(), page }, refresh);
  const changeState = async (row) => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      await confirmedWrite(`solicitudes/${row._id}/entregar`, "POST", { version: row.version }, confirm);
      setRefresh(value => value + 1);
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  const delivered = useData("movimientos", {
    desde: today(),
    hasta: today(),
    estado: "ENTREGADO",
  }, refresh);
  return (
    <section>
      {dialog}
      <h2>Despacho de hoy</h2>
      <div className="sd-summary">
        <article>
          <strong>{delivered.data?.total ?? "—"}</strong>
          <span>Movimientos entregados hoy</span>
        </article>
      </div>
      <div className="sd-toolbar">
        {canOperate && (
          <Button
            label="Nuevo despacho"
            icon="pi pi-plus"
            onClick={() => go("new")}
          />
        )}
        <Button label="Consolidado del mes" onClick={() => go("reports")} />
      </div>
      <Status {...movements} error={movements.error || delivered.error || error} />
      <MovementTable rows={movements.data?.rows} onDetail={onDetail} busy={busy} onState={canRequest ? changeState : undefined} />
      {movements.data && <Pager data={movements.data} page={page} setPage={setPage} />}
    </section>
  );
}

